import {token} from './token.mjs';

export class TokenScanner {

    constructor(tokenDefinitions) {
        this.tokenDefinitions = tokenDefinitions;
    }

    getTokenContent(tokenDefinition, text) {
        const match = text.match(tokenDefinition.contentMatcher);
        return match !== null ? match[0] : null;
    }

    toCharLiteralToken(markupText, startIndex, endIndex) {
        return token({
            name: 'CHARACTER_LITERAL',
            startIndex: startIndex,
            endIndex: endIndex,
            type: 'CHARACTER_LITERAL',
            value: markupText.slice(startIndex, endIndex),
        });
    }

    findTokenAtIndex(markupText, index) {

        for (const tokenDefinition of this.tokenDefinitions) {
            const textAtIndex = markupText.slice(index);
            const tokenContent = this.getTokenContent(tokenDefinition, textAtIndex);
            if(tokenContent === null)  continue;

            return token({
                name: tokenDefinition.name,
                type: tokenDefinition.type,
                startIndex: index,
                endIndex: index + tokenContent.length,
                value: tokenContent
            });
        }

        return null;
    }
    
    matchNextTokens(markupText, startIndex, currentIndex) {

        const tokens = []
        if(currentIndex >= markupText.length) {
            if (startIndex === currentIndex) return [];
            tokens.push(this.toCharLiteralToken(markupText, startIndex, markupText.length))
            return tokens
        }

        const token = this.findTokenAtIndex(markupText, currentIndex);

        if (token) {
            if(currentIndex > startIndex) {
                tokens.push(this.toCharLiteralToken(markupText, startIndex, currentIndex));
            }

            tokens.push(token);
            return [...tokens, ...this.matchNextTokens(markupText, token.endIndex, token.endIndex)];
        }

        return [...tokens, ...this.matchNextTokens(markupText, startIndex, currentIndex +1)];
    }

    /**
     * Scan all the tokens and text present in a markup document
     * @param {string} - a markup document
     * @returns {Array<token>} An array of all the token found in a markup document. unmatched text are token of type CHARACTER_LITERAL
     */
    scan(markupText) {

        if(!markupText || markupText.length === 0) return [];

        return this.matchNextTokens(markupText, 0, 0);
    }

}
